import types from './types';

const setPodcast = podcast => ({
  type: types.SET_PODCAST,
  payload: {
    podcast,
  },
});

export const setProfileColor = color => ({
  type: types.SET_PROFILE_COLOR,
  payload: { color },
});

export default {
  setPodcast,
};
